import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import DeleteUserModal from "./DeleteUserModal";
import { openDeleteUserModal } from "../../actions/modalActions";
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from "../../locale/messages";

import { LinkIndicateIcon } from "../Common/Assets/SvgComponent/commonSvgIcon";
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../helpers/showToaster';

import bt from '../../components/commonStyle.css';
import s from './DeleteUserForm.css';

const DeleteUserForm = () => {

    const dispatch = useDispatch();
    const { formatMessage } = useIntl();
    const [isDemoRestrict, setRestrict] = useState('false');

    const { profileId } = useSelector((state) => ({
        profileId: state?.account?.data?.profileId
    }));

    const handleClick = () => {
        if (isDemoRestrict) {
            showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
            return true;
        } else {
            dispatch(openDeleteUserModal());
        }
    };

    useEffect(() => {
        async function fetchData() {
            const isRestrict = await dispatch(userRestriction({ restrictType: 'profile', restrictValue: profileId }));
            setRestrict(isRestrict);
        }
        fetchData();
    }, []);

    return (
        <div>
            <div className={cx('inputFocusColor', 'commonListingBg', 'noMarginBottom', 'heightAuto')}>
                <DeleteUserModal />
                <h1 className={s.listingTitleText}>{formatMessage(messages.deleteAccount)}</h1>
                <p className={cx(s.deleteMessageContent)}><span className={cx(s.deleteMessageContentLabel)}>{formatMessage(messages.deleteMessageContentLabel)}</span>{' '}<span>
                    {formatMessage(messages.deleteMessageContent)}
                </span></p>
                <div className={s.textEnd}>
                    <Button className={cx(s.deleteButton, s.whiteSpaceNormal)} onClick={handleClick}>
                        <span>{formatMessage(messages.deleteMessage)}</span>
                        <LinkIndicateIcon className={cx(s.arrowIcon, 'deleteButtonArrowIcon')} />
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default withStyles(s, bt)(DeleteUserForm);

